import Sidebar from './SideBar.vue';
import SidebarItem from './SidebarItem.vue';

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize() {
    // En desktop el sidebar siempre es mini (se expande solo con hover)
    // Este método ya no alterna el estado; solo dispara resize para gráficos
    if (window.innerWidth >= 992) return;
    document.body.classList.toggle('sidebar-mini');
    this.isMinimized = !this.isMinimized;
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 180);
    setTimeout(() => {
      clearInterval(simulateWindowResize);
    }, 1000);
  },
  initMini() {
    // En desktop siempre forzar sidebar-mini (colapsado, expande con hover)
    if (window.innerWidth >= 992) {
      document.body.classList.add('sidebar-mini');
      this.isMinimized = true;
    }
    // Escuchar cambios de tamaño para aplicar/quitar sidebar-mini dinámicamente
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 992) {
        document.body.classList.add('sidebar-mini');
        this.isMinimized = true;
      } else {
        document.body.classList.remove('sidebar-mini');
        this.isMinimized = false;
      }
    });
  }
};

const SidebarPlugin = {
  install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    let app = new Vue({
      data: {
        sidebarStore: SidebarStore
      }
    });
    Vue.prototype.$sidebar = app.sidebarStore;
    Vue.component('side-bar', Sidebar);
    Vue.component('sidebar-item', SidebarItem);
    // Initialize sidebar-mini on desktop by default
    SidebarStore.initMini();
  }
};

export default SidebarPlugin;
